import { defineStore } from 'pinia'
import { encryptStorage } from 'src/utils/pinia-encryption'

export const useGuestStore = defineStore('guest', {
  state: () => ({
    guestCartNumber: null,
    guestCustomerId: null,
    guestUser: null,
    storePickupSlotId: null,
    scheduledDeliverySlotId: null,
    buyNowOrderNumbers: [],
  }),
  getters: {
    verifiedGuestCustomerId: (state) => state.guestCustomerId,
    slotBookingId: (state) => {
      return (codeName) => {
        if (codeName == 'sp') return state.storePickupSlotId
        else if (codeName == 'scd') return state.scheduledDeliverySlotId
        else return null
      }
    },
  },
  actions: {
    resetGuestUserInfo() {
      try {
        this.guestUser = null
        this.guestCustomerId = null
        this.guestCartNumber = null
      } catch (error) {
        return error
      }
    },
    setGuestUser({ guestUser = null, setCustomerID = false }) {
      try {
        this.guestUser = guestUser
        if (setCustomerID && guestUser.customerID)
          this.guestCustomerId = guestUser.customerID
      } catch (error) {
        return error
      }
    },
    resetSlots() {
      this.storePickupSlotId = null
      this.scheduledDeliverySlotId = null
    },
    setGuestCartNumber(cartNumber) {
      this.guestCartNumber = cartNumber
    },
    setSelectedSlotId({ key, val }) {
      if (val) this[key] = val
      else this[key] = null
    },
    addBuyNowOrderNumber(orderNumber) {
      if (!this.buyNowOrderNumbers.includes(orderNumber))
        this.buyNowOrderNumbers.push(orderNumber)
    },
    removeBuyNowOrderNumber(orderNumber) {
      this.buyNowOrderNumbers = this.buyNowOrderNumbers.filter(
        (num) => num !== orderNumber
      )
    },
    resetBuyNowOrderNumbers() {
      this.buyNowOrderNumbers = []
    },
  },
  // persist: true,
  persist: {
    storage: encryptStorage,
  },
})
